export const randomValue = (range: number): number => {
  return Math.floor(Math.random() * range);
}